import React from "react";
import { Col } from "react-bootstrap";
import { useMatch, useNavigate, useResolvedPath } from "react-router-dom";
import { COLOR_PRIMARY } from "../../../constants/colors";

const defaultColor = "#33383F";

const GridItem = ({ route }) => {
  const resolved = useResolvedPath(route.path);
  const navigate = useNavigate();

  const match = useMatch({ path: resolved.pathname, end: true });
  const active = Boolean(match);
  const color = active ? COLOR_PRIMARY : defaultColor;

  const handleClick = () => {
    navigate(route.path);
  };

  return (
    <Col col={12} className="col-6 mb-4">
      <div className="menu-card" onClick={() => handleClick()}>
        <div className={`wrapper-item ${active ? "active" : ""}`}>
          <route.Icon color={color} />
          <div className="item-name text-truncate px-3">{route.title}</div>
        </div>
      </div>
    </Col>
  );
};

export default GridItem;
